import React from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { withRouter, useHistory, NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import Paper from '@material-ui/core/Paper';
import GpsFixedOutlinedIcon from '@material-ui/icons/GpsFixedOutlined';
import { connect } from 'react-redux';
import { numberFormat, getDateInStringDDMMMYYYY, getDisplayName, getRequestTimeInMillis } from "../../../utils/utils";
import { trackDwebEvent } from '../../analytics'

const useStyles = makeStyles((theme) => ({
  info: {
    padding: '16px 24px',
    backgroundColor: '#d6def7',
    height: '100%',
    minHeight: 82,
    maxHeight: 82,
    borderRadius: 8,
    display: 'flex',
    flexDirection: 'row',
    color: '#0033cc',
    alignItems: 'center',
    fontWeight: 300
  },
  path: {
    width: 70,
    color: '#fff',
    backgroundColor: '#FFF',
    margin: '24px 8px'
  },
  title: {
    fontSize: 20,
    fontWeight: 300,
    cursor: 'pointer'
  },
  titleV1: {
    fontSize: 20,
    fontWeight: 300,
  },
  subTitle: {
    fontSize: 18,
    cursor: 'pointer'
  },
  connectDiv: {

  },
  connecter: {
    color: '#fff'
  },
  autoMargin: {
    marginLeft: 'auto'
  },
  titleVendor: {
    fontSize: 20,
    fontWeight: 300,
    color: '#161f34',
    cursor: 'pointer'
  },
  titleVendorV1: {
    fontSize: 20,
    fontWeight: 300,
    color: '#161f34',
  },
  subTitleAmount: {
    color: '#161f34',
    fontSize: 18,
    fontWeight: 300
  },
  normal: {
    fontSize: 18,
    color: '#161f34',
  },
}));
const Info = (props) => {
  const { location, tripDetails } = props;
  const classes = useStyles();
  let history = useHistory();
  const goToVehicleView = (index) => {
    if (tripDetails && tripDetails.vehicle && tripDetails.vehicle.id && !tripDetails.vehicle.isVehicleDeleted) {
      const vehicleId = tripDetails.vehicle.id;
      const vehicleNumberPreffix = tripDetails.vehicle.vehicleNumberPrefix;
      const vehicleNumberSuffix = tripDetails.vehicle.vehicleNumberSuffix;
      const status = tripDetails.vehicle.status ? tripDetails.vehicle.status : '';
      history.push({
        pathname: `/trucks/single-truck/${vehicleId}`,
        state: {
          id: 8,
          vehicleStatus: status || null,
          pageTitle: [vehicleNumberPreffix, vehicleNumberSuffix],
          vehicleId: vehicleId
        }
      });
    }
  }
  const goToDriverView = () => {
    if (tripDetails && tripDetails.driver && tripDetails.driver.id) {
      const driverId = tripDetails.driver.id;
      const driverName = tripDetails.driver.name;
      const status = tripDetails.driver.status ? tripDetails.driver.status : '';
      history.push({
        pathname: `/drivers/single-driver/${driverId}`,
        state: {
          id: 8,
          driverStatus: status || null,
          pageTitle: driverName ? driverName : 'Driver View',
          driverId: driverId
        }
      });

    }
  }

  const goToSupplierView = (index) => {

    if (tripDetails && tripDetails.vendor && tripDetails.vendor.id) {
      let vendorId = tripDetails.vendor.id;
      let vendorName = tripDetails.vendor.vendorName;
      trackDwebEvent("", {
        "supplier_id": vendorId,
        "supplier_name": vendorName
      });
      history.push({
        pathname: `/suppliers/single-supplier/trips/${vendorId}`,
        state: {
          id: 8,
          pageTitle: vendorName ? vendorName : 'Vendor View',
          vendorId: vendorId
        }
      });
    }
  }
  const goToPartyView = () => {
    let party = tripDetails && tripDetails.party && tripDetails.party.id ? tripDetails.party : null;
    if (party) {
      trackDwebEvent("Single Party View from Dweb", {
        party_id: party.id,
        party_name: party.partyName ? party.partyName : 'N/A'
      });
      history.push({
        pathname: `/parties/single-party/trips/${party.id}`,
        state: {
          id: 7,
          partyId: party.id || null,
          pageTitle: party.name ? party.name : 'Party View',
          openingBalanceDate: party && party.openingBalanceDate ? party.openingBalanceDate :null
        }
      });
    }
  }
  return (
    <Paper className={classes.info}>
      <div>
        <Typography className={classes.title} onClick={goToPartyView}>
          {tripDetails && tripDetails.partyName ? tripDetails.partyName : ''}
        </Typography>
        <Typography className={classes.subTitleAmount}>
          {tripDetails && tripDetails.freightAmount ? numberFormat(Number(tripDetails.freightAmount)) : ''}
        </Typography>
      </div>
      <div className={classes.autoMargin}>
        <Typography onClick={goToVehicleView} className={tripDetails && tripDetails.vendor && tripDetails.vendor.id && tripDetails.vendor.id != 0 ? tripDetails.vehicle && tripDetails.vehicle.isVehicleDeleted ? classes.titleVendorV1 : classes.titleVendor : tripDetails.vehicle && tripDetails.vehicle.isVehicleDeleted ? classes.titleV1 : classes.title}>
          {tripDetails && tripDetails.vehicle && tripDetails.vehicle.number ? tripDetails.vehicle.number : ''}
        </Typography>
        <Typography className={tripDetails && tripDetails.driver && tripDetails.driver.id ? classes.subTitle : classes.normal} onClick={goToDriverView}>
          {tripDetails && tripDetails.driver && tripDetails.driver.name ? tripDetails.driver.name : 'N/A'}
        </Typography>
      </div>
      {tripDetails && tripDetails.vendor && tripDetails.vendor.id && tripDetails.vendor.id != 0 &&
        <div className={classes.autoMargin}>
          <Typography className={classes.title} onClick={goToSupplierView}>
            {tripDetails && tripDetails.vendor && tripDetails.vendor && tripDetails.vendor.vendorName ? tripDetails.vendor.vendorName : ''}
          </Typography>
          <Typography className={classes.subTitleAmount}>
            {tripDetails && tripDetails.truckHireCost ? numberFormat(Number(tripDetails.truckHireCost)) : ''}
          </Typography>
        </div>
      }
    </Paper>
  );
}
const InfoWithRouter = withRouter(Info);
export default InfoWithRouter;